import { Input } from '@/components/ui/input';
import type { ArgumentInputProps } from './types';

export function TextInput({ arg, onChange, isError }: ArgumentInputProps) {
  const hasError = isError && arg.is_required && !String(arg.value).trim();

  return (
    <Input
      value={String(arg.value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={arg.placeholder || 'Enter value'}
      className={`h-7 ${hasError ? 'border-destructive' : ''}`}
      type="text"
      id={arg.name}
    />
  );
}
